import type { SVGProps } from "react";

/** Monochrome Google "G" mark (currentColor). Not an official multicolor wordmark. */
export function GoogleMark({
	className,
	...props
}: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="currentColor"
			aria-hidden="true"
			className={className}
			{...props}
		>
			<path d="M12 10.2v3.6h5.1c-.2 1.2-.9 2.3-1.9 3l3.1 2.4c1.8-1.7 2.9-4.1 2.9-7 0-.7-.1-1.3-.2-1.9H12z" />
			<path d="M6.6 14.3l-.9.7-2.5 1.9C4.8 19.5 8.1 21.6 12 21.6c2.7 0 5-.9 6.7-2.4l-3.1-2.4c-.9.6-2 .9-3.6.9-2.8 0-5.1-1.9-6-4.4z" />
			<path d="M3.2 7.1C2.4 8.6 2 10.3 2 12s.4 3.4 1.2 4.9l3.4-2.6C6.2 13.4 6 12.7 6 12s.2-1.4.6-2.3L3.2 7.1z" />
			<path d="M12 5.4c1.5 0 2.8.5 3.8 1.5l2.8-2.8C16.9 2.5 14.7 1.6 12 1.6 8.1 1.6 4.8 3.7 3.2 7.1l3.4 2.6C7 7.3 9.2 5.4 12 5.4z" />
		</svg>
	);
}
